import { createClient } from '@supabase/supabase-js';

// Clinician app uses the PUBLISHABLE key under Row-Level Security. This key is
// browser-safe by design; the secret key never reaches the client.
const url = import.meta.env.VITE_SUPABASE_URL;
const publishableKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

if (!url || !publishableKey) {
  // Fail loud in dev so a missing .env is obvious immediately.
  console.warn(
    '[nostos] Missing VITE_SUPABASE_URL or VITE_SUPABASE_PUBLISHABLE_KEY — copy .env.example to .env.',
  );
}

export const supabase = createClient(url, publishableKey, {
  auth: { persistSession: true, autoRefreshToken: true },
});
